// Nice: add Gmail, Hotmail, and Outlook buttons
// TODO: merge users?
import React, { useState, useEffect } from "react";
import logo from "../logo.png";
import { Link } from "react-router-dom";
import { getUserEmailFromStripeCheckoutSessionid } from "../audiblogsApi";
import queryString from "query-string";
import mixpanel from "mixpanel-browser";

function PaymentSuccess(props) {
  const [email, setEmail] = useState("");
  const { session_id: sessionId } = queryString.parse(props.location.search);

  useEffect(() => {
    getUserEmailFromStripeCheckoutSessionid(
      sessionId
    ).then(({ data: { email } }) => setEmail(email));

    mixpanel.track("Successful Subscription");
  }, [sessionId]);

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          margin: "auto",
          maxWidth: "100%",
          textAlign: "center",
        }}
      >
        <a href="https://audioread.com">
          <img
            src={logo}
            className="App-logo"
            alt="logo"
            style={{
              margin: "20px auto 0 auto",
              width: "auto",
              height: "vh",
            }}
          />
        </a>
        <h1>One Last Step!</h1>
        <div>
          Please <Link to="/signin?redirected_from=drawabox">sign in</Link> as{" "}
          {email}.
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccess;
